import { ThemeProvider, createTheme } from "@mui/material/styles";

export default function ThemeConfig({ children }) {
  const themeOptions = {
    palette: {
      primary: {
        main: "#5083ba",
      },
      secondary: {
        main: "#5083ba",
      },
      text: {
        primary: "#fff",
      },
    },
    typography: {
      fontFamily: '"Parkinsans", sans-serif',
    },
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: "#5083ba", // unchecked color
            "&.Mui-checked": {
              color: "#5083ba", // checked color
            },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: "#5083ba", // unchecked color
            "&.Mui-checked": {
              color: "#5083ba", // checked color
            },
          },
        },
      },
    },
  };

  const theme = createTheme(themeOptions);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
